export default __webpack_public_path__ + "macbook.87afa179.png";